import { createActions } from "redux-actions";
import { Dispatch } from "redux";
import { loadCallback } from "../../../utils";
import { RootState, TCb } from "../../../models";
import { APP_CONFIG } from "../../../constants";

export const AuthAcionTypes = createActions({
  CACHE_AUTH_DATA: (data) => data,
  CLEAR_AUTH_DATA: (data) => data,
});

const cacheAuthData = (input: { token: string; refreshToken: string }, cb?: TCb) => async (
  dispath: Dispatch,
  getState: () => RootState
) => {
  localStorage.setItem(APP_CONFIG.LOCAL_STORAGE_KEYS.TOKEN, input.token);

  dispath(
    AuthAcionTypes.cacheAuthData({
      data: input,
      loading: false,
    })
  );

  loadCallback(cb?.success);
};

const clearAuthData = (cb?: TCb) => async (dispath: Dispatch, getState: () => RootState) => {
  localStorage.removeItem(APP_CONFIG.LOCAL_STORAGE_KEYS.TOKEN);

  dispath(
    AuthAcionTypes.cacheAuthData({
      data: null,
      loading: false,
    })
  );

  loadCallback(cb?.success);
};

export const AuthActions = {
  cacheAuthData,
  clearAuthData,
};
